export const translations = {
  de: {
    nav: {
      home: "Start",
      services: "Leistungen",
      team: "Team",
      partners: "Partner",
      contact: "Kontakt",
      cta: "Termin Vereinbaren",
    },
    hero: {
      eyebrow: "RF KFZ // Lustenau Nº01",
      title_top: "RF · KFZ",
      title_mid: "MEISTER",
      title_bot: "BETRIEB",
      subtitle:
        "Mit über 25 Jahren Erfahrung im Kfz-Bereich. Ihr verlässlicher Partner in Lustenau für Reparaturen, Wartungen und Fahrzeuganpassungen — Meisterbriefe garantieren höchste Qualität.",
      cta_primary: "Termin Anfragen",
      cta_secondary: "Leistungen Erkunden",
      stat1_value: "25+",
      stat1_label: "Jahre Erfahrung",
      stat2_value: "2",
      stat2_label: "KFZ-Meister",
      stat3_value: "§57a",
      stat3_label: "Pickerl-Prüfstelle",
      scroll: "Scrollen",
    },
    services: {
      eyebrow: "[ 02 — Leistungen ]",
      title: "Werkstatt im Meisterstandard.",
      subtitle:
        "Von gesetzlicher Begutachtung bis zur Spezialdiagnose — alle Leistungen unter einem Dach.",
      items: [
        {
          tag: "01 / Prüfung",
          title: "Vorführen §57 a",
          desc:
            "Gesetzliche Begutachtung nach §57 a KFG. Pickerl-Prüfung für PKW, LKW und Anhänger — schnell und gewissenhaft.",
        },
        {
          tag: "02 / Diagnose",
          title: "Fehlerdiagnose",
          desc:
            "Modernste Diagnosegeräte für alle Fahrzeugmarken. Wir finden, was andere übersehen — schnell und präzise.",
        },
        {
          tag: "03 / Service",
          title: "Wartung & Service",
          desc:
            "Ölservice, Getriebespülung, Klimaservice, Bremsenservice. Komplette Fahrzeugpflege aus einer Hand.",
        },
        {
          tag: "04 / Reparatur",
          title: "Reifen & Steinschlag",
          desc:
            "Reifenservice für alle Größen, Steinschlagreparatur an Ort und Stelle. Ihr Auto bleibt mobil.",
        },
      ],
    },
    team: {
      eyebrow: "[ 03 — Werkstattmeister ]",
      title: "Sieben Köpfe. Eine Mission.",
      subtitle:
        "Vom Werkstattleiter bis zum engagierten Lehrling — alle mit Leidenschaft am Werk.",
      members: [
        { name: "Resul Ekrem", role: "Geschäftsführer · Werkstattleiter", years: "25Y" },
        { name: "Fatih Yilmaz", role: "Geschäftsführer · KFZ-Meister", years: "20Y" },
        { name: "Ibrahim Kavas", role: "KFZ-Meister", years: "8Y" },
        { name: "Arif Ilbas", role: "Allrounder · KFZ-Techniker", years: "12Y" },
      ],
    },
    atelier: {
      eyebrow: "[ Atelier Sequence ]",
      title: "Im Maschinenraum.",
      subtitle: "Wo Präzision auf Leidenschaft trifft. Jeder Handgriff dokumentiert.",
    },
    partners: {
      eyebrow: "[ 04 — Vertrauenspartner ]",
      title: "Werkstatt für alle Marken.",
    },
    contact: {
      eyebrow: "[ 05 — Kontakt ]",
      title_top: "Bringen Sie Ihr",
      title_bot: "Fahrzeug zu uns.",
      subtitle:
        "Beschreiben Sie Ihr Anliegen. Wir antworten innerhalb von 24 Stunden mit einem persönlichen Termin-Vorschlag.",
      name: "Vollständiger Name",
      email: "E-Mail",
      phone: "Telefon",
      vehicle: "Fahrzeug & Baujahr",
      service: "Leistung",
      message: "Ihr Anliegen",
      submit: "Anfrage Senden",
      sending: "Wird gesendet…",
      success: "Anfrage erhalten. Wir melden uns persönlich.",
      error: "Fehler – bitte erneut versuchen.",
      validation: "Bitte Name, E-Mail und Nachricht ausfüllen.",
      info_address: "Grindelstrasse 2 · 6890 Lustenau, Vorarlberg, AT",
      info_phone: "+43 660 290 30 54 · +43 650 310 38 01",
      info_email: "info@rf-kfz.at",
      hours: "Mo–Fr · 08:00 — 18:00 · Sa nach Vereinbarung",
    },
    footer: {
      copy: "© 2025 RF KFZ Meisterbetrieb GmbH — Alle Rechte vorbehalten.",
      legal: "Impressum · Datenschutz",
      tag: "Lustenau // Meisterbetrieb in Vorarlberg",
    },
  },
  en: {
    nav: {
      home: "Home",
      services: "Services",
      team: "Team",
      partners: "Partners",
      contact: "Contact",
      cta: "Book Appointment",
    },
    hero: {
      eyebrow: "RF KFZ // Lustenau Nº01",
      title_top: "RF · KFZ",
      title_mid: "MEISTER",
      title_bot: "BETRIEB",
      subtitle:
        "25+ years of automotive expertise. Your trusted partner in Lustenau for repairs, maintenance and vehicle customization — certified master craftsmen.",
      cta_primary: "Request Appointment",
      cta_secondary: "Explore Services",
      stat1_value: "25+",
      stat1_label: "Years Experience",
      stat2_value: "2",
      stat2_label: "Master Craftsmen",
      stat3_value: "§57a",
      stat3_label: "Inspection Station",
      scroll: "Scroll",
    },
    services: {
      eyebrow: "[ 02 — Services ]",
      title: "Workshop at master standard.",
      subtitle:
        "From statutory inspection to specialized diagnostics — every service under one roof.",
      items: [
        {
          tag: "01 / Inspection",
          title: "Vorführen §57 a",
          desc:
            "Statutory roadworthiness inspection under §57 a KFG. Pickerl certification for cars, trucks and trailers — fast and thorough.",
        },
        {
          tag: "02 / Diagnostics",
          title: "Fault Diagnostics",
          desc:
            "State-of-the-art diagnostic equipment for all vehicle brands. We find what others miss — quickly and precisely.",
        },
        {
          tag: "03 / Service",
          title: "Maintenance & Service",
          desc:
            "Oil service, transmission flush, A/C service, brake service. Complete vehicle care from a single source.",
        },
        {
          tag: "04 / Repair",
          title: "Tires & Stone Chip",
          desc:
            "Tire service in every size, on-the-spot stone chip repair. We keep your car on the road.",
        },
      ],
    },
    team: {
      eyebrow: "[ 03 — Master Craftsmen ]",
      title: "Seven minds. One mission.",
      subtitle:
        "From workshop director to dedicated apprentices — all united by passion for the craft.",
      members: [
        { name: "Resul Ekrem", role: "Managing Director · Workshop Lead", years: "25Y" },
        { name: "Fatih Yilmaz", role: "Managing Director · KFZ-Meister", years: "20Y" },
        { name: "Ibrahim Kavas", role: "KFZ-Meister", years: "8Y" },
        { name: "Arif Ilbas", role: "All-rounder · KFZ Technician", years: "12Y" },
      ],
    },
    atelier: {
      eyebrow: "[ Atelier Sequence ]",
      title: "Inside the workshop.",
      subtitle: "Where precision meets passion. Every move documented.",
    },
    partners: {
      eyebrow: "[ 04 — Trusted By ]",
      title: "Workshop for every marque.",
    },
    contact: {
      eyebrow: "[ 05 — Contact ]",
      title_top: "Bring your",
      title_bot: "vehicle to us.",
      subtitle:
        "Describe your case. We respond within 24 hours with a personal appointment proposal.",
      name: "Full Name",
      email: "Email",
      phone: "Phone",
      vehicle: "Vehicle & Year",
      service: "Service",
      message: "Your Brief",
      submit: "Send Request",
      sending: "Sending…",
      success: "Inquiry received. We will reply personally.",
      error: "Error — please try again.",
      validation: "Please fill in name, email and message.",
      info_address: "Grindelstrasse 2 · 6890 Lustenau, Vorarlberg, AT",
      info_phone: "+43 660 290 30 54 · +43 650 310 38 01",
      info_email: "info@rf-kfz.at",
      hours: "Mon–Fri · 08:00 — 18:00 · Sat by appointment",
    },
    footer: {
      copy: "© 2025 RF KFZ Meisterbetrieb GmbH — All rights reserved.",
      legal: "Imprint · Privacy",
      tag: "Lustenau // Meisterbetrieb in Vorarlberg",
    },
  },
};
